var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/video-categories.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-3cb99dea!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/video-categories.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/VideoCategories.vue
// module id = 1368
// module chunks = 1